module.exports = __webpack_public_path__ + "img/stack09.ed7fb81c.svg";